import { computed, ref } from 'vue'
import { createInjectionState } from '@vueuse/core'
import type { TCoil } from '../../../types'
import { useCoilsQuery } from '../query/useCoilsQuery'

const [useProvideCoilsModule, useCoilModule] = createInjectionState(() => {
  const modelId = ref<number | undefined>()
  const modelChildId = ref<number | undefined>()
  const expandedRows = ref<Record<number, boolean>>({})
  const form = ref<TCoil>({})
  const models = computed(() => !!modelId.value && !!modelChildId.value)
  const moduleQuery = useCoilsQuery({
    modelId: computed(() => Number(modelId.value)),
    modelChildId: computed(() => Number(modelChildId.value)),
    enableQuery: {
      loadRecords: computed(
        () =>
          !isNaN(Number(modelId.value)) && !isNaN(Number(modelChildId.value)),
      ),
    },
  })

  const onLoadCoils = (purchaseId: number, detailId: number) => {
    modelId.value = purchaseId
    modelChildId.value = detailId
  }

  const onResetIds = () => {
    modelId.value = undefined
    modelChildId.value = undefined
  }

  const onAdd = async (payload: TCoil) => {
    await moduleQuery.addRecord.mutateAsync(payload)
    onResetIds()
  }

  const onEdit = async (payload: TCoil) => {
    await moduleQuery.editRecord.mutateAsync(payload)
    onResetIds()
  }

  const onDelete = async (payload: TCoil) => {
    await moduleQuery.deleteRecord.mutateAsync(payload)
    onResetIds()
  }

  const coils = computed(() => moduleQuery.loadRecords?.data?.value)

  const isLoading = computed(
    () =>
      moduleQuery.addRecord.isLoading.value ||
      moduleQuery.editRecord.isLoading.value ||
      moduleQuery.deleteRecord.isLoading.value,
  )

  return {
    form,
    coils,
    isLoading,
    modelChildId,
    modelId,
    models,
    expandedRows,
    onAdd,
    onEdit,
    onLoadCoils,
    onDelete,
  }
})

export { useProvideCoilsModule, useCoilModule }
